import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d8c87b7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d8c87b7a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c87b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c87b7a')) {
      api.createRecord('d8c87b7a', component.options)
    } else {
      api.reload('d8c87b7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d8c87b7a&scoped=true", function () {
      api.rerender('d8c87b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/jingdongGoods/index.vue"
export default component.exports